<template>
  <div class="container-fluid py-4 configuration-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-shop fs-2 text-success"></i>

        <h2 class="fw-bold mb-0">
          Configuration Boutique Pro
        </h2>
      </div>

      <!-- Bouton créer -->
      <button
        v-if="!configuration && $store.getters.hasPermission('CREATE_CONFIGURATION_BOUTIQUE')"
        class="btn btn-success btn-lg shadow-sm btn-boutique mt-2 mt-md-0"
        @click="creer"
        :disabled="isLoading"
      >
        <i class="bi bi-plus-circle me-1"></i>
        Créer configuration
      </button>

      <!-- Bouton modifier -->
      <button
        v-else-if="$store.getters.hasPermission('EDIT_CONFIGURATION_BOUTIQUE')"
        class="btn btn-lg shadow-sm btn-outline-success btn-boutique mt-2 mt-md-0"
        @click="modifier"
      >
        <i class="bi bi-pencil-square me-1"></i>
        Modifier
      </button>

    </div>

    <!-- ================= LOADER ================= -->
    <div v-if="isLoading" class="text-center my-5">

      <div
        class="spinner-border text-success"
        role="status"
        style="width: 4rem; height: 4rem;"
      ></div>

      <p class="mt-3">
        Chargement de la configuration boutique...
      </p>

    </div>

    <!-- ================= CONFIGURATION ================= -->
    <div
      v-else
      class="card shadow-sm rounded card-boutique"
    >

      <div class="card-body p-4">

        <!-- Configuration trouvée -->
        <div v-if="configuration">

          <div
            class="d-flex align-items-center gap-2 mb-4 success-title"
          >
            <i class="bi bi-check-circle-fill"></i>

            <h5 class="fw-bold mb-0">
              Configuration boutique enregistrée
            </h5>
          </div>

          <div class="row g-4">

            <!-- Nom boutique -->
            <div class="col-12 col-md-6">

              <div class="info-card">

                <div class="info-icon">
                  <i class="bi bi-shop-window"></i>
                </div>

                <div>
                  <small class="text-muted">
                    Nom de la boutique
                  </small>

                  <h6 class="fw-bold mb-0">
                    {{ configuration.nom }}
                  </h6>
                </div>

              </div>

            </div>

            <!-- Ville -->
            <div class="col-12 col-md-6">

              <div class="info-card">

                <div class="info-icon">
                  <i class="bi bi-geo-alt"></i>
                </div>

                <div>
                  <small class="text-muted">
                    Ville
                  </small>

                  <h6 class="fw-bold mb-0">
                    {{ configuration.ville }}
                  </h6>
                </div>

              </div>

            </div>

            <!-- Adresse -->
            <div class="col-12 col-md-6">

              <div class="info-card">

                <div class="info-icon">
                  <i class="bi bi-pin-map"></i>
                </div>

                <div>
                  <small class="text-muted">
                    Adresse
                  </small>

                  <h6 class="fw-bold mb-0">
                    {{ configuration.adresse }}
                  </h6>
                </div>

              </div>

            </div>

            <!-- Téléphone -->
            <div class="col-12 col-md-6">

              <div class="info-card">

                <div class="info-icon">
                  <i class="bi bi-telephone"></i>
                </div>

                <div>
                  <small class="text-muted">
                    Téléphone
                  </small>

                  <h6 class="fw-bold mb-0">
                    {{ configuration.telephone }}
                  </h6>
                </div>

              </div>

            </div>

            <!-- Description -->
            <div class="col-12">

              <div class="description-box">

                <div class="d-flex align-items-center gap-2 mb-2">
                  <i class="bi bi-card-text text-success"></i>

                  <h6 class="fw-bold mb-0">
                    Description
                  </h6>
                </div>

                <p class="mb-0 text-secondary">
                  {{ configuration.description || 'Aucune description disponible.' }}
                </p>

              </div>

            </div>

          </div>

        </div>

        <!-- Aucun résultat -->
        <div
          v-else
          class="empty-state text-center py-5"
        >

          <div class="empty-icon mb-3">
            <i class="bi bi-shop"></i>
          </div>

          <h4 class="fw-bold">
            Aucune configuration boutique trouvée
          </h4>

          <p class="text-secondary">
            Veuillez configurer la Boutique Baraka pour activer la gestion des ventes et du stock.
          </p>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      configuration: null,
      isLoading: true
    };
  },

  methods: {

    async getConfiguration() {
      try {
        const response = await api.getItems('configurations');
        const data = response.data.data;

        this.configuration =
          Array.isArray(data) ? data[0] : null;

      } catch (error) {
        console.error(
          'Erreur lors de la récupération de la configuration boutique',
          error
        );
      } finally {
        this.isLoading = false;
      }
    },

    creer() {
      this.$router.push({
        name: 'create_configuration_boutique'
      });
    },

    modifier() {
      this.$router.push({
        name: 'edit_configuration_systeme',
        params: {
          id: this.configuration.id
        }
      });
    }

  },

  created() {
    this.getConfiguration();
  }
};
</script>

<style scoped>

/* ================= PAGE ================= */
.configuration-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* ================= HEADER ================= */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
}

/* ================= BUTTON ================= */
.btn-boutique {
  border-radius: 12px;
}

/* ================= CARD ================= */
.card-boutique {
  border: none;
  border-radius: 20px;
  background: white;
  box-shadow: 0 4px 18px rgba(0,0,0,0.06);
}

/* ================= SUCCESS ================= */
.success-title {
  color: #10b981;
}

/* ================= INFO CARD ================= */
.info-card {
  display: flex;
  align-items: center;
  gap: 15px;

  background: #f8fafc;
  border: 1px solid #e2e8f0;

  border-radius: 16px;
  padding: 18px;

  transition: 0.3s;
}

.info-card:hover {
  transform: translateY(-3px);
}

/* ================= ICON ================= */
.info-icon {
  width: 55px;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 14px;

  background: linear-gradient(135deg, #064e3b, #10b981);

  color: white;
  font-size: 22px;
}

/* ================= DESCRIPTION ================= */
.description-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
}

/* ================= EMPTY ================= */
.empty-state {
  padding: 40px 20px;
}

.empty-icon {
  width: 90px;
  height: 90px;
  margin: auto;

  border-radius: 50%;

  background: linear-gradient(135deg, #064e3b, #10b981);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 40px;
}

/* ================= RESPONSIVE ================= */
@media (max-width: 768px) {

  .header-boutique {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .info-card {
    padding: 15px;
  }

  .info-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

}

</style>